import React from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb} from 'antd';
import routes from '../../router/router'
export default class BreadcrumbTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: null
    }
  }
  getPath = () => {
    let _titleMap = {};
    let _routeMap = {};
    let pathSnippets = [];
    routes.forEach((v, i) => {
      _titleMap[v.title] = v.path;
      _routeMap[v.path] = {
        title: v.title,
        path: v.path,
        parentTitle: v.parent || '',
        parentPath: v.parent
          ? _titleMap[v.parent]
          : ''
      };
    })
    let _pathObj = _routeMap[this.props.routeData.location.pathname];
    if (_pathObj && _pathObj.parentTitle) {
      pathSnippets.push({path: _pathObj.parentPath, title: _pathObj.parentTitle});
    }
    if (_pathObj){pathSnippets.push({path: _pathObj.path, title: _pathObj.title})}
    this.setState({
        breadcrumbItems: pathSnippets.map((item, index) => {
            return (
              <Breadcrumb.Item key={item.path}>
                <Link to={item.path}>
                  {item.title}
                </Link>
              </Breadcrumb.Item>
            );
          })
    })
  }
  componentDidUpdate(prevProps) {
    if (prevProps.routeData.location.pathname !== this.props.routeData.location.pathname) {
        this.getPath();
    }
  }
  UNSAFE_componentWillMount() {
    this.getPath();
  }
  render() {
    return <Breadcrumb>{this.state.breadcrumbItems}</Breadcrumb>;
  }
}
